/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ring_WorldInputs */

const en_ring_world = /** @type {(inputs: Ring_WorldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The world, through TIL`)
};

/**
* | output |
* | --- |
* | "The world, through TIL" |
*
* @param {Ring_WorldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ring_world = /** @type {((inputs?: Ring_WorldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ring_WorldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ring_world(inputs)
});